<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
    <g fill="none" fill-rule="evenodd" transform="translate(-31 -20)">
        <g transform="translate(31.325 20)">
            <path class="widget-icon--status" fill="#000" fill-rule="nonzero" d="M14.357 12.5c0-1.33 1.543-2.5 2.315-3.191 2.025-1.65 3.471-4.575 3.76-7.98C20.48.64 20.095 0 19.612 0H5.825c-.482 0-.868.638-.82 1.33.29 3.404 1.736 6.33 3.76 8.032.772.638 2.315 1.808 2.315 3.138 0 1.277-1.543 2.447-2.314 3.138-2.025 1.702-3.472 4.628-3.76 8.032-.05.692.337 1.33.819 1.33h13.74c.53 0 .916-.638.82-1.33-.29-3.404-1.736-6.33-3.76-8.032-.772-.638-2.267-1.808-2.267-3.138z"/>
        </g>
    </g>
</svg>
